/**
 * Displays related content when a selected word in an article, video, etc is hovered/clicked on
 */
function init_story_streams(){

    $( ".stream-tag" ).on({
        click: function(e) {
            storyStreamClick(e);
        },
        mouseenter: function(e) {
            storyStreamHover(e);
        },
        touchstart: function(e) {
            storyStreamClick(e);
        },
        touchmove: function(e) {
            setTimeout(function(){
                storyStreamClick(e);
            },250);
        },
        touchleave: function(e) {
            setTimeout(function(){
                storyStreamClick(e);
            },250);
        }
    });

    $(document).on('click', '', function(e){
        if(!$(e.target).hasClass('stream-tag')){
            $('.story-stream-hover-wrapper').hide();
        }
    });

}

function storyStreamClick(e){
    /*
  This code figures out the targets (span click or hovered) location
  Compares it to the alpha location wrapper div and figures out the top and left position
  that overlay story stream should appear at
   */
    var ele_text = $(e.target).text();
    $(e.target).html(ele_text+'<img class="ss_loader" src="//notifications.realclearpolitics.com/web_notifications/images/ajax-loader2.gif">');
    $(".story-stream-hover-wrapper").hide();

    //var ele_url = ele_text.toLowerCase();
    //ele_url = ele_url.replace(/ /g, '_').replace(/\W+/g, "");

    //use the same basename making process equal to cms side
    var ele_url = Utils.make_slug(ele_text);

    $(".story-stream-hover-wrapper .title-wrapper .title").html('<a href="/stream/?topic='+ele_url+'">' + ele_text + '</a>');
    populateStreamTag(ele_url, e, 'click');
}

function storyStreamHover(e){

    /*
  This code figures out the targets (span click or hovered) location
  Compares it to the alpha location wrapper div and figures out the top and left position
  that overlay story stream should appear at
   */

    var ele_text = $(e.target).text();
    $(e.target).html(ele_text+'<img class="ss_loader" src="//notifications.realclearpolitics.com/web_notifications/images/ajax-loader2.gif">');
    $(".story-stream-hover-wrapper").hide();

    //var ele_url = ele_text.toLowerCase();
    //ele_url = ele_url.replace(/ /g, '_').replace(/\W+/g, "");

    //use the same basename making process equal to cms side
    var ele_url = Utils.make_slug(ele_text);

    $(".story-stream-hover-wrapper .title-wrapper .title").html('<a href="/stream/?topic='+ele_url+'">' + ele_text + '</a>');
    populateStreamTag(ele_url, e, 'hover');

    //keeps stream info box open when hovered over - desktop
    $( ".story-stream-hover-wrapper" ).hover(
        function() {
            $( this ).show();
        }, function() {
            $( this ).hide();
        }
    );
}

//populate story stream popups for any template that uses them
function populateStreamTag(tag, e, ga_action){

    var ss = $.extend(true, {}, $StoryStream);

    ss.topic = tag;
    //Set the limit in StoryStream object. This is the number of stories that will appear at a time.
    ss.limit = 12;
    //Set which DOM element is the content container
    ss.container = $(".story-stream-hover-wrapper");

    ss.event = e;
    ss.ga_action = ga_action;

    ss.loop_limit = 5;
    ss.pushed_to_html = 0;
    ss.fail_limit = 10;

    ss.stories_added = [];
    ss.html = "";

    ss.current_article = $('.article-title h1').text();

    //Override the print_stories function.
    //This is so the markup for this page gets generated on continue_stream(),
    // instead of the default markup
    ss.print_stories = function(stories_array) {
        stream_tags[tag] = '';
        var urlArray = [];
        for(var i=0; i<stories_array.length; i++) {
            if(this.filter.indexOf(stories_array[i].type) != -1) {
                if(this.pushed_to_html >= this.loop_limit){
                    break;
                }

                if(urlArray.indexOf(stories_array[i].content_url) != -1
                    || this.current_article == this.clear_html_entities(stories_array[i].heading1.replace(/\\/g, "")) ){
                    continue;
                } //end urlArray check

                urlArray.push(stories_array[i].content_url);

                this.stories_added.push([stories_array[i].content_url, stories_array[i].heading1]);

                this.pushed_to_html = this.pushed_to_html + 1;

            } //end if type check
        } //end for loop

        if(this.pushed_to_html >= this.loop_limit){
            this.is_finished = true;
            this.build_up_html();
            reposition_story_stream_widget(this.event, this.ga_action, true);
        }

    } //end print stories

    ss.clear_html_entities = function(text){
        var txt = document.createElement("textarea");
        txt.innerHTML = text;
        return txt.value;
    }

    ss.build_up_html = function(){
        if(this.stories_added.length > 0){
            this.html = "";

            var limiter = 5;
            if(this.stories_added.length < 5){
                limiter = this.stories_added.length;
            }

            for(var i = 0; i < limiter; i++){
                this.html += '<li><a href="'+this.stories_added[i][0].replace(/\\/g, "")+'">'+this.stories_added[i][1].replace(/\\/g, "")+'</a></li>';
            }

            $(".story-stream-hover-wrapper .recent-link ul").html(this.html);
        }else{
            $(".story-stream-hover-wrapper .recent-link ul").html("No Posts Available");
        }
    }

    ss.finished_callback = function(){
        if(this.fail_count >= this.fail_limit){
            this.is_finished = true;
            this.build_up_html();
            reposition_story_stream_widget(this.event, this.ga_action, false);
        }
    }

    //init stream - build links
    ss.continue_stream();
}

function reposition_story_stream_widget (e, ga_action, completed){

    $('.ss_loader').remove();

    var ele = $(e.target.parentNode);

    var target_offset = $(e.target).offset();
    var target_width = $(e.target).width();
    var target_height = $(e.target).height();
    var target_left = target_offset.left;
    var target_top = target_offset.top;

    var scrollTop     = $(window).scrollTop(),
        elementOffset = ele.offset().top,
        distance      = (elementOffset - scrollTop);

    var windowWidth = $(window).outerWidth();
    var height = $(".story-stream-hover-wrapper").height();
    var alpha_offset = $('.alpha').offset();

    var hoverLeft;
    var hoverTop;

    hoverTop = target_top - alpha_offset.top - (target_height/2);
    if( windowWidth > 768 ){
        hoverLeft = target_left - alpha_offset.left - (target_width/2) - 20;
        if(hoverLeft < -42){
            hoverLeft = -42;
        }
        $( ".mobile-close-btn" ).hide();
    }else{
        hoverLeft = "0px";
        if( distance > height ){
            hoverTop = hoverTop + 40;
        }
        $( ".mobile-close-btn" ).show();
    }

    var appear_on_top = false;
    if( distance <= height ){ //show below placeholder
        hoverTop = hoverTop - 10;
        $(".story-stream-hover-wrapper").css({
            position: "absolute",
            top: hoverTop,
            left: hoverLeft
        }).show();

        $( ".story-stream-hover-tab-up" ).show();
        $( ".story-stream-hover-tab-down" ).hide();
        appear_on_top = false;
    }else{ //show above  placeholder
        hoverTop = hoverTop - 401;
        $(".story-stream-hover-wrapper").css({
            position: "absolute",
            top: hoverTop,
            left: hoverLeft
        }).show();

        $( ".story-stream-hover-tab-down" ).show();
        $( ".story-stream-hover-tab-up" ).hide();
        appear_on_top = true;
    }

    if(ga_action == 'click'){
        $( ".mobile-close-btn" ).show();
    }else{
        $( ".mobile-close-btn" ).hide();
    }

    $( ".mobile-close-btn" ).click(function(){
        $( ".story-stream-hover-wrapper" ).hide();
    });

    var position_data = {
        target_top:target_top - alpha_offset.top - (target_height/2)-210,
        appear_on_top: appear_on_top
    }

    if(position_data.appear_on_top){
        var wrapper_height = $(".story-stream-hover-wrapper").height();
        if(parseInt(wrapper_height) < 350){
            var difference = 350 - wrapper_height;
            var current_top_pos = parseFloat($(".story-stream-hover-wrapper").css('top'));
            var new_top_pos = current_top_pos + difference;

            if(parseInt(new_top_pos) <= parseInt(position_data.target_top) ){
                $(".story-stream-hover-wrapper").css('top', new_top_pos+'px');
            }else{
                $(".story-stream-hover-wrapper").css('top', (position_data.target_top-20)+'px');
            }
        }
    }

    var bc = $('body').attr('class');
    var data = {
        'ge_action' : ga_action,
        'ge_category' : 'System Widget Interaction',
        'ge_label' : 'Inline Story Stream : '+bc
    };
    try{
        _gaq.push(['_trackEvent', data['ge_category'], data['ge_action'], data['ge_label']]);
    } catch(err) {}
}

export default init_story_streams;